/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BlacklistPatientDto,
  CreatePatientDto,
  CreatePatientNoteDto,
  DuplicateMatchResponse,
  MergePatientsDto,
  MergeResultResponse,
  PatientDetailResponse,
  PatientFacetValueResponse,
  PatientFacetsResponse,
  PatientImportCommitBody,
  PatientImportDownloadTemplateParams,
  PatientImportFormatResponse,
  PatientImportPreviewBody,
  PatientImportResultResponse,
  PatientNoteResponse,
  PatientNotesList200,
  PatientNotesListParams,
  PatientRegistrationLimitResponse,
  PatientResponse,
  PatientsDuplicateCheckParams,
  PatientsList200,
  PatientsListParams,
  PatientsRecycleBin200,
  PatientsRecycleBinParams,
  UpdatePatientDto,
  UpdatePatientNoteDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * فهرست صفحه‌بندی‌شدهٔ بیماران کلینیک با فیلترهای پزشک معالج، برچسب، شهر، بازهٔ آخرین مراجعه (شمسی)، نوبت آینده، محدودشده، انصراف از پیامک و بدهکار بودن (hasOutstandingBalance، نیازمند finance.view_revenue). کاربری که دسترسی «مشاهده بیماران همه پزشکان» ندارد فقط بیماران خودش را می‌بیند. مرتب‌سازی بر اساس نام ممکن نیست چون نام رمزنگاری‌شده ذخیره می‌شود.
 * @summary فهرست بیماران
 */
export const patientsList = (
    params?: PatientsListParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientsList200>(
      {url: `/api/v1/patients`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientsListQueryKey = (params?: PatientsListParams,) => {
    return [
    `/api/v1/patients`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientsListQueryOptions = <TData = Awaited<ReturnType<typeof patientsList>>, TError = void>(params?: PatientsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsList>>> = ({ signal }) => patientsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsListQueryResult = NonNullable<Awaited<ReturnType<typeof patientsList>>>
export type PatientsListQueryError = void


export function usePatientsList<TData = Awaited<ReturnType<typeof patientsList>>, TError = void>(
 params: undefined |  PatientsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsList>>,
          TError,
          Awaited<ReturnType<typeof patientsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsList<TData = Awaited<ReturnType<typeof patientsList>>, TError = void>(
 params?: PatientsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsList>>,
          TError,
          Awaited<ReturnType<typeof patientsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsList<TData = Awaited<ReturnType<typeof patientsList>>, TError = void>(
 params?: PatientsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست بیماران
 */

export function usePatientsList<TData = Awaited<ReturnType<typeof patientsList>>, TError = void>(
 params?: PatientsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پروندهٔ تازه می‌سازد. شمارهٔ موبایل کلید هویت بیمار در این کلینیک است و تکراری بودن آن — حتی با پرونده‌های بایگانی‌شده — باعث خطای ۴۰۹ می‌شود. اگر شمارهٔ پرونده ندهید، به شکل «۱۴۰۴-۰۱۴۲» ساخته می‌شود.
 * @summary ثبت بیمار جدید
 */
export const patientsCreate = (
    createPatientDto: CreatePatientDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientResponse>(
      {url: `/api/v1/patients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPatientDto, signal
    },
      );
    }




export const getPatientsCreateMutationKey = () => ['patientsCreate'] as const;

export const getPatientsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsCreate>>, TError,PatientsCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientsCreate>>, TError,PatientsCreateMutationVariables, TContext> => {

const mutationKey = getPatientsCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientsCreate>>, PatientsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientsCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof patientsCreate>>>
    export type PatientsCreateMutationBody = CreatePatientDto
    export type PatientsCreateMutationError = void
    export type PatientsCreateMutationVariables = {data: CreatePatientDto}

    /**
 * @summary ثبت بیمار جدید
 */
export const usePatientsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsCreate>>, TError,PatientsCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientsCreate>>,
        TError,
        PatientsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPatientsCreateMutationOptions(options), queryClient);
    }
    /**
 * پرونده‌هایی که حذف شده‌اند و هنوز در مهلت نگهداری کلینیک هستند. پس از پایان این مهلت، کار پاک‌سازی رکوردها و فایل‌های ذخیره‌شده را برای همیشه حذف می‌کند.
 * @summary سطل بازیافت بیماران
 */
export const patientsRecycleBin = (
    params?: PatientsRecycleBinParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientsRecycleBin200>(
      {url: `/api/v1/patients/recycle-bin`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientsRecycleBinQueryKey = (params?: PatientsRecycleBinParams,) => {
    return [
    `/api/v1/patients/recycle-bin`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientsRecycleBinQueryOptions = <TData = Awaited<ReturnType<typeof patientsRecycleBin>>, TError = unknown>(params?: PatientsRecycleBinParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRecycleBin>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsRecycleBinQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsRecycleBin>>> = ({ signal }) => patientsRecycleBin(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsRecycleBin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsRecycleBinQueryResult = NonNullable<Awaited<ReturnType<typeof patientsRecycleBin>>>
export type PatientsRecycleBinQueryError = unknown


export function usePatientsRecycleBin<TData = Awaited<ReturnType<typeof patientsRecycleBin>>, TError = unknown>(
 params: undefined |  PatientsRecycleBinParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRecycleBin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsRecycleBin>>,
          TError,
          Awaited<ReturnType<typeof patientsRecycleBin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsRecycleBin<TData = Awaited<ReturnType<typeof patientsRecycleBin>>, TError = unknown>(
 params?: PatientsRecycleBinParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRecycleBin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsRecycleBin>>,
          TError,
          Awaited<ReturnType<typeof patientsRecycleBin>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsRecycleBin<TData = Awaited<ReturnType<typeof patientsRecycleBin>>, TError = unknown>(
 params?: PatientsRecycleBinParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRecycleBin>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary سطل بازیافت بیماران
 */

export function usePatientsRecycleBin<TData = Awaited<ReturnType<typeof patientsRecycleBin>>, TError = unknown>(
 params?: PatientsRecycleBinParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRecycleBin>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsRecycleBinQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * شهرها و برچسب‌هایی که در پرونده‌ها به کار رفته‌اند، هرکدام با تعداد پرونده، پرتکرارترین اول (حداکثر ۲۰۰ مورد از هرکدام). برای پر کردن انتخابگر شهر و برچسب پیش از تایپ. شمارش‌ها مثل خود فهرست محدود به پزشک است: کاربری که «مشاهده بیماران همه پزشکان» ندارد فقط بیماران خودش را می‌شمارد. سطل بازیافت حساب نمی‌شود.
 * @summary مقادیر قابل فیلتر فهرست بیماران
 */
export const patientsFacets = (

 signal?: AbortSignal
) => {


      return apiClient<PatientFacetsResponse>(
      {url: `/api/v1/patients/facets`, method: 'GET', signal
    },
      );
    }




export const getPatientsFacetsQueryKey = () => {
    return [
    `/api/v1/patients/facets`
    ] as const;
    }


export const getPatientsFacetsQueryOptions = <TData = Awaited<ReturnType<typeof patientsFacets>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFacets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsFacetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsFacets>>> = ({ signal }) => patientsFacets(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsFacets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsFacetsQueryResult = NonNullable<Awaited<ReturnType<typeof patientsFacets>>>
export type PatientsFacetsQueryError = void


export function usePatientsFacets<TData = Awaited<ReturnType<typeof patientsFacets>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFacets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsFacets>>,
          TError,
          Awaited<ReturnType<typeof patientsFacets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsFacets<TData = Awaited<ReturnType<typeof patientsFacets>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFacets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsFacets>>,
          TError,
          Awaited<ReturnType<typeof patientsFacets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsFacets<TData = Awaited<ReturnType<typeof patientsFacets>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFacets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مقادیر قابل فیلتر فهرست بیماران
 */

export function usePatientsFacets<TData = Awaited<ReturnType<typeof patientsFacets>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFacets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsFacetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همهٔ برچسب‌های پرونده‌ها با تعداد، پرتکرارترین اول (حداکثر ۲۰۰). همان بخش tags در /patients/facets، برای جایی که فقط برچسب لازم است. محدود به پزشک، مثل فهرست.
 * @summary برچسب‌های به‌کاررفته در پرونده‌ها
 */
export const patientsTags = (

 signal?: AbortSignal
) => {


      return apiClient<PatientFacetValueResponse[]>(
      {url: `/api/v1/patients/tags`, method: 'GET', signal
    },
      );
    }




export const getPatientsTagsQueryKey = () => {
    return [
    `/api/v1/patients/tags`
    ] as const;
    }


export const getPatientsTagsQueryOptions = <TData = Awaited<ReturnType<typeof patientsTags>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsTags>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsTags>>> = ({ signal }) => patientsTags(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsTagsQueryResult = NonNullable<Awaited<ReturnType<typeof patientsTags>>>
export type PatientsTagsQueryError = void


export function usePatientsTags<TData = Awaited<ReturnType<typeof patientsTags>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsTags>>,
          TError,
          Awaited<ReturnType<typeof patientsTags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsTags<TData = Awaited<ReturnType<typeof patientsTags>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsTags>>,
          TError,
          Awaited<ReturnType<typeof patientsTags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsTags<TData = Awaited<ReturnType<typeof patientsTags>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsTags>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary برچسب‌های به‌کاررفته در پرونده‌ها
 */

export function usePatientsTags<TData = Awaited<ReturnType<typeof patientsTags>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsTags>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsTagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * چند پرونده ثبت شده، سقف پلن چقدر است و آیا همین حالا می‌توان پروندهٔ تازه ساخت — همان ارقامی که ثبت بیمار با آن‌ها تصمیم می‌گیرد، تا پنل پیش از باز کردن فرم «ارتقای پلن» را پیشنهاد دهد. سقف و باقی‌ماندهٔ null یعنی نامحدود.
 * @summary ظرفیت ثبت بیمار در پلن فعلی
 */
export const patientsRegistrationLimit = (

 signal?: AbortSignal
) => {


      return apiClient<PatientRegistrationLimitResponse>(
      {url: `/api/v1/patients/registration-limit`, method: 'GET', signal
    },
      );
    }




export const getPatientsRegistrationLimitQueryKey = () => {
    return [
    `/api/v1/patients/registration-limit`
    ] as const;
    }


export const getPatientsRegistrationLimitQueryOptions = <TData = Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsRegistrationLimitQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsRegistrationLimit>>> = ({ signal }) => patientsRegistrationLimit(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsRegistrationLimitQueryResult = NonNullable<Awaited<ReturnType<typeof patientsRegistrationLimit>>>
export type PatientsRegistrationLimitQueryError = void


export function usePatientsRegistrationLimit<TData = Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsRegistrationLimit>>,
          TError,
          Awaited<ReturnType<typeof patientsRegistrationLimit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsRegistrationLimit<TData = Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsRegistrationLimit>>,
          TError,
          Awaited<ReturnType<typeof patientsRegistrationLimit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsRegistrationLimit<TData = Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ظرفیت ثبت بیمار در پلن فعلی
 */

export function usePatientsRegistrationLimit<TData = Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsRegistrationLimit>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsRegistrationLimitQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پیش از ثبت پروندهٔ جدید، شمارهٔ موبایل یا کد ملی را بررسی می‌کند. تطبیق از راه نمایهٔ کور انجام می‌شود، پس فقط تطابق کامل پیدا می‌شود. پاسخ فقط نام و شمارهٔ پرونده را برمی‌گرداند، نه اطلاعات بالینی.
 * @summary بررسی تکراری بودن بیمار
 */
export const patientsDuplicateCheck = (
    params?: PatientsDuplicateCheckParams,
 signal?: AbortSignal
) => {


      return apiClient<DuplicateMatchResponse>(
      {url: `/api/v1/patients/duplicate-check`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientsDuplicateCheckQueryKey = (params?: PatientsDuplicateCheckParams,) => {
    return [
    `/api/v1/patients/duplicate-check`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientsDuplicateCheckQueryOptions = <TData = Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError = void>(params?: PatientsDuplicateCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsDuplicateCheckQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsDuplicateCheck>>> = ({ signal }) => patientsDuplicateCheck(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsDuplicateCheckQueryResult = NonNullable<Awaited<ReturnType<typeof patientsDuplicateCheck>>>
export type PatientsDuplicateCheckQueryError = void


export function usePatientsDuplicateCheck<TData = Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError = void>(
 params: undefined |  PatientsDuplicateCheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsDuplicateCheck>>,
          TError,
          Awaited<ReturnType<typeof patientsDuplicateCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsDuplicateCheck<TData = Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError = void>(
 params?: PatientsDuplicateCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsDuplicateCheck>>,
          TError,
          Awaited<ReturnType<typeof patientsDuplicateCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsDuplicateCheck<TData = Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError = void>(
 params?: PatientsDuplicateCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary بررسی تکراری بودن بیمار
 */

export function usePatientsDuplicateCheck<TData = Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError = void>(
 params?: PatientsDuplicateCheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsDuplicateCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsDuplicateCheckQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پروندهٔ کامل با فیلدهای رمزگشایی‌شده. هر بار خواندن این مسیر در گزارش فعالیت ثبت می‌شود.
 * @summary مشخصات یک بیمار
 */
export const patientsFindOne = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PatientResponse>(
      {url: `/api/v1/patients/${id}`, method: 'GET', signal
    },
      );
    }




export const getPatientsFindOneQueryKey = (id: string,) => {
    return [
    `/api/v1/patients/${id}`
    ] as const;
    }


export const getPatientsFindOneQueryOptions = <TData = Awaited<ReturnType<typeof patientsFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsFindOne>>> = ({ signal }) => patientsFindOne(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof patientsFindOne>>>
export type PatientsFindOneQueryError = void


export function usePatientsFindOne<TData = Awaited<ReturnType<typeof patientsFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientsFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsFindOne<TData = Awaited<ReturnType<typeof patientsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientsFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsFindOne<TData = Awaited<ReturnType<typeof patientsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مشخصات یک بیمار
 */

export function usePatientsFindOne<TData = Awaited<ReturnType<typeof patientsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فقط فیلدهایی که فرستاده‌اید تغییر می‌کنند. تغییر نام، نمایهٔ جست‌وجو را از هر دو بخش نام بازسازی می‌کند؛ تغییر موبایل یا کد ملی دوباره برای تکراری بودن بررسی می‌شود. شمارهٔ پرونده قابل تغییر نیست.
 * @summary ویرایش بیمار
 */
export const patientsUpdate = (
    id: string,
    updatePatientDto: UpdatePatientDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientResponse>(
      {url: `/api/v1/patients/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePatientDto, signal
    },
      );
    }




export const getPatientsUpdateMutationKey = () => ['patientsUpdate'] as const;

export const getPatientsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsUpdate>>, TError,PatientsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientsUpdate>>, TError,PatientsUpdateMutationVariables, TContext> => {

const mutationKey = getPatientsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientsUpdate>>, PatientsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientsUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof patientsUpdate>>>
    export type PatientsUpdateMutationBody = UpdatePatientDto
    export type PatientsUpdateMutationError = void
    export type PatientsUpdateMutationVariables = {id: string;data: UpdatePatientDto}

    /**
 * @summary ویرایش بیمار
 */
export const usePatientsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsUpdate>>, TError,PatientsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientsUpdate>>,
        TError,
        PatientsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getPatientsUpdateMutationOptions(options), queryClient);
    }
    /**
 * حذف نرم است: هیچ رکوردی و هیچ فایلی از بین نمی‌رود و پرونده قابل بازگرداندن است. حذف واقعی از راه «درخواست حذف اطلاعات» انجام می‌شود.
 * @summary انتقال بیمار به سطل بازیافت
 */
export const patientsRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/patients/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getPatientsRemoveMutationKey = () => ['patientsRemove'] as const;

export const getPatientsRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsRemove>>, TError,PatientsRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientsRemove>>, TError,PatientsRemoveMutationVariables, TContext> => {

const mutationKey = getPatientsRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientsRemove>>, PatientsRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  patientsRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof patientsRemove>>>

    export type PatientsRemoveMutationError = unknown
    export type PatientsRemoveMutationVariables = {id: string}

    /**
 * @summary انتقال بیمار به سطل بازیافت
 */
export const usePatientsRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsRemove>>, TError,PatientsRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientsRemove>>,
        TError,
        PatientsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getPatientsRemoveMutationOptions(options), queryClient);
    }
    /**
 * مشخصات، نوبت‌های آینده و گذشته، آخرین جلسات، تعداد تصاویر، رضایت‌نامه‌ها، پکیج‌ها، امتیاز باشگاه مشتریان، پیگیری‌های باز و ارقام مالی — در یک درخواست. هر بخشی که دسترسی آن را نداشته باشید null برمی‌گردد (نه آرایهٔ خالی)، تا پنل بتواند «اجازه ندارید» را از «چیزی وجود ندارد» تشخیص دهد.
 * @summary نمای کامل پروندهٔ بیمار
 */
export const patientsOverview = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PatientDetailResponse>(
      {url: `/api/v1/patients/${id}/overview`, method: 'GET', signal
    },
      );
    }




export const getPatientsOverviewQueryKey = (id: string,) => {
    return [
    `/api/v1/patients/${id}/overview`
    ] as const;
    }


export const getPatientsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof patientsOverview>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsOverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientsOverviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientsOverview>>> = ({ signal }) => patientsOverview(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof patientsOverview>>>
export type PatientsOverviewQueryError = void


export function usePatientsOverview<TData = Awaited<ReturnType<typeof patientsOverview>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsOverview>>,
          TError,
          Awaited<ReturnType<typeof patientsOverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsOverview<TData = Awaited<ReturnType<typeof patientsOverview>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientsOverview>>,
          TError,
          Awaited<ReturnType<typeof patientsOverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientsOverview<TData = Awaited<ReturnType<typeof patientsOverview>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary نمای کامل پروندهٔ بیمار
 */

export function usePatientsOverview<TData = Awaited<ReturnType<typeof patientsOverview>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientsOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientsOverviewQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مسیر جداگانه دارد چون رویداد جداگانه‌ای در گزارش فعالیت است: چه کسی، چه زمانی و به چه دلیل. هنگام فعال‌کردن، دلیل الزامی است.
 * @summary محدود کردن یا رفع محدودیت بیمار
 */
export const patientsSetBlacklist = (
    id: string,
    blacklistPatientDto: BlacklistPatientDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientResponse>(
      {url: `/api/v1/patients/${id}/blacklist`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: blacklistPatientDto, signal
    },
      );
    }




export const getPatientsSetBlacklistMutationKey = () => ['patientsSetBlacklist'] as const;

export const getPatientsSetBlacklistMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsSetBlacklist>>, TError,PatientsSetBlacklistMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientsSetBlacklist>>, TError,PatientsSetBlacklistMutationVariables, TContext> => {

const mutationKey = getPatientsSetBlacklistMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientsSetBlacklist>>, PatientsSetBlacklistMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientsSetBlacklist(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientsSetBlacklistMutationResult = NonNullable<Awaited<ReturnType<typeof patientsSetBlacklist>>>
    export type PatientsSetBlacklistMutationBody = BlacklistPatientDto
    export type PatientsSetBlacklistMutationError = void
    export type PatientsSetBlacklistMutationVariables = {id: string;data: BlacklistPatientDto}

    /**
 * @summary محدود کردن یا رفع محدودیت بیمار
 */
export const usePatientsSetBlacklist = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsSetBlacklist>>, TError,PatientsSetBlacklistMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientsSetBlacklist>>,
        TError,
        PatientsSetBlacklistMutationVariables,
        TContext
      > => {
      return useMutation(getPatientsSetBlacklistMutationOptions(options), queryClient);
    }
    /**
 * جلسات، نوبت‌ها، تصاویر، رضایت‌نامه‌ها، پرداخت‌ها، پکیج‌ها، یادآوری‌ها و پیوندهای اپلیکیشن بیمار از پروندهٔ تکراری به این پرونده منتقل می‌شوند و خودِ آن بایگانی می‌شود. امتیاز باشگاه مشتریان به‌صورت دو رکورد تازه در دفتر امتیاز منتقل می‌گردد، چون آن دفتر فقط‌افزودنی است. هر دو پرونده باید برای شما قابل دسترسی باشند.
 * @summary ادغام پروندهٔ تکراری در این پرونده
 */
export const patientsMerge = (
    id: string,
    mergePatientsDto: MergePatientsDto,
 signal?: AbortSignal
) => {


      return apiClient<MergeResultResponse>(
      {url: `/api/v1/patients/${id}/merge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mergePatientsDto, signal
    },
      );
    }




export const getPatientsMergeMutationKey = () => ['patientsMerge'] as const;

export const getPatientsMergeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsMerge>>, TError,PatientsMergeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientsMerge>>, TError,PatientsMergeMutationVariables, TContext> => {

const mutationKey = getPatientsMergeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientsMerge>>, PatientsMergeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientsMerge(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientsMergeMutationResult = NonNullable<Awaited<ReturnType<typeof patientsMerge>>>
    export type PatientsMergeMutationBody = MergePatientsDto
    export type PatientsMergeMutationError = void
    export type PatientsMergeMutationVariables = {id: string;data: MergePatientsDto}

    /**
 * @summary ادغام پروندهٔ تکراری در این پرونده
 */
export const usePatientsMerge = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsMerge>>, TError,PatientsMergeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientsMerge>>,
        TError,
        PatientsMergeMutationVariables,
        TContext
      > => {
      return useMutation(getPatientsMergeMutationOptions(options), queryClient);
    }
    /**
 * تا پایان مهلت نگهداری کلینیک امکان‌پذیر است. پس از آن پرونده در انتظار پاک‌سازی نهایی است و بازگرداندن آن پذیرفته نمی‌شود.
 * @summary بازگرداندن بیمار از سطل بازیافت
 */
export const patientsRestore = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PatientResponse>(
      {url: `/api/v1/patients/${id}/restore`, method: 'POST', signal
    },
      );
    }




export const getPatientsRestoreMutationKey = () => ['patientsRestore'] as const;

export const getPatientsRestoreMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsRestore>>, TError,PatientsRestoreMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientsRestore>>, TError,PatientsRestoreMutationVariables, TContext> => {

const mutationKey = getPatientsRestoreMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientsRestore>>, PatientsRestoreMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  patientsRestore(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientsRestoreMutationResult = NonNullable<Awaited<ReturnType<typeof patientsRestore>>>

    export type PatientsRestoreMutationError = void
    export type PatientsRestoreMutationVariables = {id: string}

    /**
 * @summary بازگرداندن بیمار از سطل بازیافت
 */
export const usePatientsRestore = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientsRestore>>, TError,PatientsRestoreMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientsRestore>>,
        TError,
        PatientsRestoreMutationVariables,
        TContext
      > => {
      return useMutation(getPatientsRestoreMutationOptions(options), queryClient);
    }
    /**
 * یادداشت‌های سنجاق‌شده اول می‌آیند. یادداشت‌های «فقط پزشکان» تنها با دسترسی «مشاهده یادداشت‌های محرمانه» دیده می‌شوند و یادداشت‌های «فقط نویسنده» تنها برای نویسندهٔ خودشان — این سطح با هیچ دسترسی‌ای باز نمی‌شود. خواندن هر یادداشت محرمانه در گزارش فعالیت ثبت می‌شود.
 * @summary یادداشت‌های پرونده
 */
export const patientNotesList = (
    patientId: string,
    params?: PatientNotesListParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientNotesList200>(
      {url: `/api/v1/patients/${patientId}/notes`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientNotesListQueryKey = (patientId: string,
    params?: PatientNotesListParams,) => {
    return [
    `/api/v1/patients/${patientId}/notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientNotesListQueryOptions = <TData = Awaited<ReturnType<typeof patientNotesList>>, TError = void>(patientId: string,
    params?: PatientNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientNotesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientNotesListQueryKey(patientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientNotesList>>> = ({ signal }) => patientNotesList(patientId,params, signal);





   return  { queryKey, queryFn, enabled: patientId !== null && patientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientNotesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientNotesListQueryResult = NonNullable<Awaited<ReturnType<typeof patientNotesList>>>
export type PatientNotesListQueryError = void


export function usePatientNotesList<TData = Awaited<ReturnType<typeof patientNotesList>>, TError = void>(
 patientId: string,
    params: undefined |  PatientNotesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientNotesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientNotesList>>,
          TError,
          Awaited<ReturnType<typeof patientNotesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientNotesList<TData = Awaited<ReturnType<typeof patientNotesList>>, TError = void>(
 patientId: string,
    params?: PatientNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientNotesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientNotesList>>,
          TError,
          Awaited<ReturnType<typeof patientNotesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientNotesList<TData = Awaited<ReturnType<typeof patientNotesList>>, TError = void>(
 patientId: string,
    params?: PatientNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientNotesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یادداشت‌های پرونده
 */

export function usePatientNotesList<TData = Awaited<ReturnType<typeof patientNotesList>>, TError = void>(
 patientId: string,
    params?: PatientNotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientNotesList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientNotesListQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * متن یادداشت رمزنگاری‌شده ذخیره می‌شود و هرگز در گزارش فعالیت نوشته نمی‌شود. ثبت یادداشت «فقط پزشکان» نیازمند دسترسی «مشاهده یادداشت‌های محرمانه» است، وگرنه یادداشت در کشویی می‌افتد که خودتان نمی‌توانید بازش کنید.
 * @summary ثبت یادداشت بالینی
 */
export const patientNotesCreate = (
    patientId: string,
    createPatientNoteDto: CreatePatientNoteDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientNoteResponse>(
      {url: `/api/v1/patients/${patientId}/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPatientNoteDto, signal
    },
      );
    }




export const getPatientNotesCreateMutationKey = () => ['patientNotesCreate'] as const;

export const getPatientNotesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientNotesCreate>>, TError,PatientNotesCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientNotesCreate>>, TError,PatientNotesCreateMutationVariables, TContext> => {

const mutationKey = getPatientNotesCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientNotesCreate>>, PatientNotesCreateMutationVariables> = (props) => {
          const {patientId,data} = props ?? {};

          return  patientNotesCreate(patientId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientNotesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof patientNotesCreate>>>
    export type PatientNotesCreateMutationBody = CreatePatientNoteDto
    export type PatientNotesCreateMutationError = void
    export type PatientNotesCreateMutationVariables = {patientId: string;data: CreatePatientNoteDto}

    /**
 * @summary ثبت یادداشت بالینی
 */
export const usePatientNotesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientNotesCreate>>, TError,PatientNotesCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientNotesCreate>>,
        TError,
        PatientNotesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPatientNotesCreateMutationOptions(options), queryClient);
    }
    /**
 * فقط نویسندهٔ یادداشت می‌تواند آن را ویرایش کند. یادداشتی که نام نویسندهٔ اصلی را دارد ولی دیگری متنش را عوض کرده، سند جعلی است.
 * @summary ویرایش یادداشت
 */
export const patientNotesUpdate = (
    patientId: string,
    noteId: string,
    updatePatientNoteDto: UpdatePatientNoteDto,
 signal?: AbortSignal
) => {


      return apiClient<PatientNoteResponse>(
      {url: `/api/v1/patients/${patientId}/notes/${noteId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePatientNoteDto, signal
    },
      );
    }




export const getPatientNotesUpdateMutationKey = () => ['patientNotesUpdate'] as const;

export const getPatientNotesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientNotesUpdate>>, TError,PatientNotesUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientNotesUpdate>>, TError,PatientNotesUpdateMutationVariables, TContext> => {

const mutationKey = getPatientNotesUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientNotesUpdate>>, PatientNotesUpdateMutationVariables> = (props) => {
          const {patientId,noteId,data} = props ?? {};

          return  patientNotesUpdate(patientId,noteId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientNotesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof patientNotesUpdate>>>
    export type PatientNotesUpdateMutationBody = UpdatePatientNoteDto
    export type PatientNotesUpdateMutationError = void
    export type PatientNotesUpdateMutationVariables = {patientId: string;noteId: string;data: UpdatePatientNoteDto}

    /**
 * @summary ویرایش یادداشت
 */
export const usePatientNotesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientNotesUpdate>>, TError,PatientNotesUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientNotesUpdate>>,
        TError,
        PatientNotesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getPatientNotesUpdateMutationOptions(options), queryClient);
    }
    /**
 * حذف نرم است. نویسنده می‌تواند یادداشت خودش را حذف کند؛ حذف یادداشت دیگران نیازمند دسترسی «حذف بیمار» است.
 * @summary حذف یادداشت
 */
export const patientNotesRemove = (
    patientId: string,
    noteId: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/patients/${patientId}/notes/${noteId}`, method: 'DELETE', signal
    },
      );
    }




export const getPatientNotesRemoveMutationKey = () => ['patientNotesRemove'] as const;

export const getPatientNotesRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientNotesRemove>>, TError,PatientNotesRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientNotesRemove>>, TError,PatientNotesRemoveMutationVariables, TContext> => {

const mutationKey = getPatientNotesRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientNotesRemove>>, PatientNotesRemoveMutationVariables> = (props) => {
          const {patientId,noteId} = props ?? {};

          return  patientNotesRemove(patientId,noteId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientNotesRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof patientNotesRemove>>>

    export type PatientNotesRemoveMutationError = unknown
    export type PatientNotesRemoveMutationVariables = {patientId: string;noteId: string}

    /**
 * @summary حذف یادداشت
 */
export const usePatientNotesRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientNotesRemove>>, TError,PatientNotesRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientNotesRemove>>,
        TError,
        PatientNotesRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getPatientNotesRemoveMutationOptions(options), queryClient);
    }
    /**
 * ستون‌ها، الزامی‌بودن، راهنما و همهٔ عنوان‌هایی که به هر ستون نگاشت می‌شوند. پنل از همین برای ساخت صفحهٔ راهنما استفاده می‌کند تا با پارسر هم‌قدم بماند.
 * @summary ساختار فایل ورودی بیماران
 */
export const patientImportFormat = (

 signal?: AbortSignal
) => {


      return apiClient<PatientImportFormatResponse>(
      {url: `/api/v1/onboarding/patients/import/format`, method: 'GET', signal
    },
      );
    }




export const getPatientImportFormatQueryKey = () => {
    return [
    `/api/v1/onboarding/patients/import/format`
    ] as const;
    }


export const getPatientImportFormatQueryOptions = <TData = Awaited<ReturnType<typeof patientImportFormat>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportFormat>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientImportFormatQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientImportFormat>>> = ({ signal }) => patientImportFormat(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientImportFormat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientImportFormatQueryResult = NonNullable<Awaited<ReturnType<typeof patientImportFormat>>>
export type PatientImportFormatQueryError = unknown


export function usePatientImportFormat<TData = Awaited<ReturnType<typeof patientImportFormat>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportFormat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientImportFormat>>,
          TError,
          Awaited<ReturnType<typeof patientImportFormat>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientImportFormat<TData = Awaited<ReturnType<typeof patientImportFormat>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportFormat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientImportFormat>>,
          TError,
          Awaited<ReturnType<typeof patientImportFormat>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientImportFormat<TData = Awaited<ReturnType<typeof patientImportFormat>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportFormat>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ساختار فایل ورودی بیماران
 */

export function usePatientImportFormat<TData = Awaited<ReturnType<typeof patientImportFormat>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportFormat>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientImportFormatQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فایل خالی با عنوان‌های فارسی، یک ردیف نمونه و برگهٔ «راهنما». ستون‌ها در اکسل با قالب متنی ساخته می‌شوند تا صفر ابتدای شمارهٔ موبایل و کد ملی حذف نشود.
 * @summary دانلود فایل نمونهٔ ورود بیماران
 */
export const patientImportDownloadTemplate = (
    params?: PatientImportDownloadTemplateParams,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/onboarding/patients/import/template`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientImportDownloadTemplateQueryKey = (params?: PatientImportDownloadTemplateParams,) => {
    return [
    `/api/v1/onboarding/patients/import/template`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientImportDownloadTemplateQueryOptions = <TData = Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError = unknown>(params?: PatientImportDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientImportDownloadTemplateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientImportDownloadTemplate>>> = ({ signal }) => patientImportDownloadTemplate(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientImportDownloadTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof patientImportDownloadTemplate>>>
export type PatientImportDownloadTemplateQueryError = unknown


export function usePatientImportDownloadTemplate<TData = Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError = unknown>(
 params: undefined |  PatientImportDownloadTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientImportDownloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof patientImportDownloadTemplate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientImportDownloadTemplate<TData = Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError = unknown>(
 params?: PatientImportDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientImportDownloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof patientImportDownloadTemplate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientImportDownloadTemplate<TData = Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError = unknown>(
 params?: PatientImportDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دانلود فایل نمونهٔ ورود بیماران
 */

export function usePatientImportDownloadTemplate<TData = Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError = unknown>(
 params?: PatientImportDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientImportDownloadTemplate>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientImportDownloadTemplateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فایل را می‌خواند، هر ردیف را اعتبارسنجی می‌کند و تکراری‌ها را با نمایهٔ کور تشخیص می‌دهد — بدون هیچ نوشتنی. گزارش خطا به تفکیک شمارهٔ سطرِ همان فایل برمی‌گردد.
 * @summary بررسی آزمایشی فایل بیماران
 */
export const patientImportPreview = (
    patientImportPreviewBody: PatientImportPreviewBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, patientImportPreviewBody.file);

      return apiClient<PatientImportResultResponse>(
      {url: `/api/v1/onboarding/patients/import/preview`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPatientImportPreviewMutationKey = () => ['patientImportPreview'] as const;

export const getPatientImportPreviewMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientImportPreview>>, TError,PatientImportPreviewMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientImportPreview>>, TError,PatientImportPreviewMutationVariables, TContext> => {

const mutationKey = getPatientImportPreviewMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientImportPreview>>, PatientImportPreviewMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientImportPreview(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientImportPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof patientImportPreview>>>
    export type PatientImportPreviewMutationBody = PatientImportPreviewBody
    export type PatientImportPreviewMutationError = void
    export type PatientImportPreviewMutationVariables = {data: PatientImportPreviewBody}

    /**
 * @summary بررسی آزمایشی فایل بیماران
 */
export const usePatientImportPreview = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientImportPreview>>, TError,PatientImportPreviewMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientImportPreview>>,
        TError,
        PatientImportPreviewMutationVariables,
        TContext
      > => {
      return useMutation(getPatientImportPreviewMutationOptions(options), queryClient);
    }
    /**
 * هر ردیف سالم به یک پروندهٔ واقعی تبدیل می‌شود؛ ردیف‌های خطادار یا تکراری رد می‌شوند و در گزارش می‌آیند. بارگذاری دوبارهٔ فایل اصلاح‌شده بی‌خطر است، چون تکراری‌ها دوباره ساخته نمی‌شوند.
 * @summary ثبت قطعی فایل بیماران
 */
export const patientImportCommit = (
    patientImportCommitBody: PatientImportCommitBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, patientImportCommitBody.file);

      return apiClient<PatientImportResultResponse>(
      {url: `/api/v1/onboarding/patients/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPatientImportCommitMutationKey = () => ['patientImportCommit'] as const;

export const getPatientImportCommitMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientImportCommit>>, TError,PatientImportCommitMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientImportCommit>>, TError,PatientImportCommitMutationVariables, TContext> => {

const mutationKey = getPatientImportCommitMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientImportCommit>>, PatientImportCommitMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientImportCommit(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientImportCommitMutationResult = NonNullable<Awaited<ReturnType<typeof patientImportCommit>>>
    export type PatientImportCommitMutationBody = PatientImportCommitBody
    export type PatientImportCommitMutationError = void
    export type PatientImportCommitMutationVariables = {data: PatientImportCommitBody}

    /**
 * @summary ثبت قطعی فایل بیماران
 */
export const usePatientImportCommit = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientImportCommit>>, TError,PatientImportCommitMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientImportCommit>>,
        TError,
        PatientImportCommitMutationVariables,
        TContext
      > => {
      return useMutation(getPatientImportCommitMutationOptions(options), queryClient);
    }
